export const DRAWER_WIDTH = 272 as const;
